import {
    WidgetCustomStreamManager,
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { WidgetStreamByRequestUidStreamManager } from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import State from 'store/State';
import { VenueAnalysisByOrderIdsOrSymbolStreamRequest } from 'widgets/venueAnalysis/api/VenueAnalysisByOrderIdsOrSymbolStreamRequest';
import {
    getStreamRequestInfosForSymbols,
    getWidgetStreamRequestInfo,
    OrderIdsStreamKey,
} from './VenueAnalysisStreamRequest';
import { WidgetId } from 'widgets/WidgetId';
import { DataServices } from 'store/Services';

export const venueAnalysisStreamConfig: WidgetStreamByRequestUidConfig<VenueAnalysisByOrderIdsOrSymbolStreamRequest> =
    {
        channelDestination: 'startVenueAnalysisByOrderIdsOrSymbolStream',
        managerFactory(
            options: WidgetCustomManagedStreamOptions
        ): WidgetCustomStreamManager {
            return new WidgetStreamByRequestUidStreamManager({
                ...options,
                checkOrderIds: true,
                clearOnNewRequest: (requestInfo) =>
                    requestInfo.streamKey === OrderIdsStreamKey,
            });
        },
        getWidgetStreamRequestInfo(
            state: State,
            services: DataServices,
            id: WidgetId,
            activeInputUsesOrdersStream: boolean
        ) {
            return Promise.resolve(
                getWidgetStreamRequestInfo(
                    state,
                    id,
                    activeInputUsesOrdersStream
                )
            );
        },
        getStreamRequestInfosForSymbols(
            state: State,
            services: DataServices,
            symbols: string[]
        ) {
            return Promise.resolve(
                getStreamRequestInfosForSymbols(state, symbols)
            );
        },
    };
